import { useEffect, useState } from 'react';

/**
 * Using this hook will cause Phrase not to call the reader manager's default pause handler.
 * This works by self reporting to the Phrase component that your phrase item will handle the pause.
 * The Phrase timer is automatically cleared to pause the reader manager from moving forward once pauseDetect turns true.
 * You must then handle the pause yourself and at the end, call finishHandlePause to allow the reader manager to resume.
 * @param {*} props 
 * @returns 
 */
export default function usePauseControl(props) {

    const { paused, setWillHandlePause, pausePhrase, resumePhrase, doneHandlingPause, pauseControlDisabled } = props;

    // This pauseControlDisabled prop is only used in SingleWord.js, ideally, we will remove 
    // it and just use composition pattern in SingleWord.js to support a mode (tutor) without pause control.
    const [ shouldHandlePause, setShouldHandlePause ] = useState(pauseControlDisabled ? false : true);

    /**
     * self report that we will handle the pause
     */
    useEffect(() => {

        if(!setWillHandlePause || !pausePhrase || !resumePhrase || !doneHandlingPause) {
            throw new Error('usePauseControl requires setWillHandlePause, pausePhrase, resumePhrase, and doneHandlingPause to be passed in as props');
        }
        console.log("assuming pause control")
        setWillHandlePause(shouldHandlePause);
    }, []);

    /**
     * pause reader manager if pause detected
     */
    useEffect(() => {
        // after passing pause control back to the reader manager, we should not handle the pause again
        if (paused && shouldHandlePause) {
            console.log("usePauseControl: handlePause")
            handlePause();
        }
    }, [paused]);

    function handlePause() {
        pausePhrase();
    }

    /**
     * resets the reader manager pause state to false
     */
    function finishHandlePause() {
        doneHandlingPause();
        resumePhrase();
    }

    /**
     * optionally pass pause control back to the reader manager at any point
     */
    function passPauseControlBackToReaderManager() {
        console.log("passPauseControlBackToReaderManager")
        setShouldHandlePause(false);
        setWillHandlePause(false);
    }

    function takeOverPauseControl() {
        console.log("takeOverPauseControl")
        setShouldHandlePause(true);
        setWillHandlePause(true);
    }

    /**
     * returns the API functions for your component to use
     */
    return {
        shouldHandlePause,
        finishHandlePause,
        passPauseControlBackToReaderManager,
        takeOverPauseControl
    };
}
